import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["entity"],
    _excluded2 = ["entity"],
    _excluded3 = ["description", "file"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ImgixImg from './index';
import { path } from '@uswitch/ev-utils/obj';
import { useEntity } from '@uswitch/ev-utils/context/selectors';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var ProviderImage = function ProviderImage(_ref) {
  var entity = _ref.entity,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useEntity = useEntity(entity),
      name = _useEntity.name,
      image = _useEntity.image;

  return _jsx(ImgixImg, _objectSpread(_objectSpread({}, props), {}, {
    alt: name,
    src: image
  }));
};

var ImgixImgConnected = function ImgixImgConnected(_ref2) {
  var entity = _ref2.entity,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var _useEntity2 = useEntity(entity),
      description = _useEntity2.description,
      file = _useEntity2.file,
      imageProps = _objectWithoutProperties(_useEntity2, _excluded3);

  var aspectRatio = (file === null || file === void 0 ? void 0 : file.details) && file.details.image.height / file.details.image.width;
  var width = props.width;
  var height = props.height || width && aspectRatio && width * aspectRatio;
  return _jsx(ImgixImg, _objectSpread(_objectSpread(_objectSpread({}, props), imageProps), {}, {
    alt: description || imageProps.title,
    src: path(['url'], file),
    width: width,
    height: height,
    sx: {
      height: 'auto'
    },
    aspectRatio: aspectRatio
  }));
};

export default ImgixImgConnected;
//# sourceMappingURL=connected.js.map